import React, { useEffect } from 'react';

const Modal = ({ title, onClose, children, size = 'md', loading = false }) => {
  const sizeClasses = {
    sm: 'sm:max-w-sm',
    md: 'sm:max-w-md',
    lg: 'sm:max-w-lg',
    xl: 'sm:max-w-xl',
    '2xl': 'sm:max-w-2xl',
    full: 'sm:max-w-full'
  }[size];

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.keyCode === 27) onClose();
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [onClose]);

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto bg-gray-900/60 backdrop-blur-xs flex items-end sm:items-center justify-center p-0 sm:p-4 animate-fade-in">
      {/* Backdrop overlay listener */}
      <div className="fixed inset-0" onClick={!loading ? onClose : undefined} aria-hidden="true" />

      {/* Modal Container */}
      <div className={`relative bg-white w-full rounded-t-2xl sm:rounded-xl shadow-xl transform transition-all ${sizeClasses} max-h-[92dvh] sm:max-h-[90vh] flex flex-col overflow-hidden`}>
        
        {/* Header Section */}
        <div className="px-4 py-4 sm:px-6 border-b border-gray-100 flex items-center justify-between bg-white flex-shrink-0">
          <h3 className="text-base sm:text-lg font-bold text-gray-900 truncate pr-4">
            {title}
          </h3>
          <button
            type="button"
            className="p-2 -mr-2 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition flex-shrink-0"
            onClick={onClose}
            disabled={loading}
            aria-label="Close modal"
          >
            <svg className="h-5 w-5 sm:h-6 sm:w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Dynamic Content Body */}
        <div className="overflow-y-auto p-4 sm:p-6 text-sm text-gray-700 min-h-0 flex-1">
          {children}
        </div>
        
      </div>
    </div>
  );
};

export default Modal;